export const defaultPreset = {
  patternScaleX: 25,
  patternScaleY: 25,
  waveSpeed: 2,
  colorSpeed: 1,
  rotationAngle: 0.56,
  canvasWidth: 1130,
  canvasHeight: 520,
  colorAValue: [0.5, 0.5, 0.5],
  colorBValue: [0.5, 0.5, 0.5],
  colorCValue: [0.4, 0.4, 0.4],
  colorDValue: [0.2, 0.4, 0.6],
};

export const vertexShader = `
attribute vec2 uv;
attribute vec2 position;
varying vec2 vUv;
void main() {
  vUv = uv;
  gl_Position = vec4(position, 0, 1);
}
`;

export const fragmentShaderTemplate = `
precision mediump float;
uniform float uTime;
uniform vec2 uResolution;
uniform vec2 uPatternScale;
uniform float uWaveSpeed;
uniform float uColorSpeed;
uniform float uRotationAngle;
uniform vec3 uColorA;
uniform vec3 uColorB;
uniform vec3 uColorC;
uniform vec3 uColorD;
varying vec2 vUv;

const float TAU = 6.28318530718;

vec2 rotate(vec2 v, float a) {
  float s = sin(a);
  float c = cos(a);
  return mat2(c, -s, s, c) * v;
}

vec3 palette(float t, vec3 a, vec3 b, vec3 c, vec3 d) {
  vec3 result;
  result.r = a.r + b.r * cos(TAU * (c.r * t + d.r));
  result.g = a.g + b.g * cos(TAU * (c.g * t + d.g));
  result.b = a.b + b.b * cos(TAU * (c.b * t + d.b));
  return result;
}

void main() {
  vec2 uv = gl_FragCoord.xy / uResolution;
  vec2 centeredUV = uv - 0.5;
  vec2 rotatedUV = rotate(centeredUV, uRotationAngle) + 0.5;

  vec2 tile = rotatedUV * uPatternScale;
  vec2 tileUV = fract(tile);
  float tileIdX = floor(tile.x);

  float wave = sin(rotatedUV.y + tileIdX * 0.5 + uTime * uWaveSpeed);
  float x = 1.0 - (tileUV.x + wave * 0.5 + 0.5);

  float colorPhase = (rotatedUV.x + rotatedUV.y) * 3.0 + uTime * uColorSpeed;
  float animatedSin = sin(colorPhase) * 0.5 + 0.5;

  vec3 a = uColorA;
  vec3 b = uColorB;
  vec3 c = uColorC;
  vec3 d = vec3(animatedSin, 0.10, 0.0) + uColorD;

  vec3 color = palette(x, a, b, c, d);
  gl_FragColor = vec4(color, 1.0);
}
`;
